import MainPageManutencao from '@/screens/manutencao/MainPage'
import CadastrarFotosReurb from '@/screens/manutencao/CadastrarFotosReurb'
import RecallPlanta from '@/screens/manutencao/RecallPlanta'
import MoverProcessos from '@/screens/manutencao/MoverProcessos'
import MovimentarProcessos from '@/screens/manutencao/MovimentarProcessos'
import DistribuirProcessos from '@/screens/manutencao/DistribuirProcessos'
import VoltarCaixaProcessos from '@/screens/manutencao/VoltarCaixaProcessos'
import GestaoFilaAnaliseAutomatizada from '@/screens/manutencao/GestaoFilaAnaliseAutomatizada.vue'
import AtualizarProcessos from '@/screens/manutencao/AtualizarProcessos.vue'
import MoverPorRemessa from '@/screens/manutencao/MoverPorRemessa'
import TrocarUsuario from '../screens/manutencao/TrocarUsuario.vue'
import RetificarEmMassa from '../screens/manutencao/RetificarEmMassa.vue'
import AjustarProcessos from '@/screens/manutencao/AjustarProcessos'
import GerenciarModulos from '../screens/manutencao/GerenciarModulos.vue'
import VerificaStatusProcesso from '../screens/manutencao/VerificaStatusProcesso.vue'
import EncerrarConversa from '@/screens/manutencao/EncerrarConversa'
import VisualizarConversa from '../screens/manutencao/VisualizarConversa.vue'
import WapClients from '../screens/manutencao/WapClients.vue'
import InfoSistema from '../screens/manutencao/InfoSistema.vue'
import ProcessosComCarGerado from '../screens/manutencao/ProcessosComCarGerado.vue'
import ModelosListagem from '@/screens/analise/ModelosListagem.vue'
import ChaveSeguranca from '../screens/manutencao/ChaveSeguranca'

const manutencao = [
  {
    path: '/manutencao',
    name: 'manutencao',
    component: MainPageManutencao,
    meta: {
      isPublic: false
    },
    children: [
      {
        path: '/manutencao/cadastrar-fotos-reurb',
        name: 'CAIXA_PROCESSO',
        component: CadastrarFotosReurb,
        meta: {
          isPublic: false,
          routeGroup: 'CAIXA_PROCESSO'
        }
      },
      {
        path: '/manutencao/recall-planta',
        name: 'REACLL_PLANTA',
        component: RecallPlanta,
        meta: {
          isPublic: false,
          routeGroup: 'REACLL_PLANTA'
        }
      },
      {
        path: '/mover-processos',
        name: 'MOVE_PROCESSO',
        component: MoverProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'MOVE_PROCESSO'
        }
      },
      {
        path: '/info-sistema',
        name: 'INFO_SISTEMA',
        component: InfoSistema,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'INFO_SISTEMA'
        }
      },
      {
        path: '/movimentar-processos',
        name: 'MOVER_PROCESSO',
        component: MovimentarProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'MOVER_PROCESSO'
        }
      },
      {
        path: '/manutencao/ajustar-processos',
        name: 'AJUSTAR_PROCESSOS',
        component: AjustarProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'AJUSTAR_PROCESSOS'
        }
      },
      {
        path: '/manutencao/voltar-caixa-processo',
        name: 'VOLTAR_CAIXA_PROCESSOS',
        component: VoltarCaixaProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'VOLTAR_CAIXA_PROCESSOS'
        }
      },
      {
        path: '/manutencao/distribuir-processos',
        name: 'TRAMITA_PROCESSO',
        component: DistribuirProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'TRAMITA_PROCESSO'
        }
      },
      {
        path: '/manutencao/voltar-processos',
        name: 'VOLTA_PROCESSO',
        component: VoltarCaixaProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'VOLTA_PROCESSO'
        }
      },
      {
        path: '/manutencao/atualizar-processos',
        name: 'ATUALIZAR_PROCESSO',
        component: AtualizarProcessos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'ATUALIZAR_PROCESSO'
        }
      },
      {
        path: '/manutencao/mover-remessa',
        name: 'MOVER_POR_REMESSA',
        component: MoverPorRemessa,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'MOVER_POR_REMESSA'
        }
      },
      {
        path: '/manutencao/gestao-fila-analise',
        name: 'GESTAO_FILA_ANALISE',
        component: GestaoFilaAnaliseAutomatizada,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'GESTAO_FILA_ANALISE'
        }
      },
      {
        path: '/manutencao/trocar-usuario',
        name: 'TROCAR_USUARIO',
        component: TrocarUsuario,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'TROCAR_USUARIO'
        }
      },
      {
        path: '/manutencao/retificar-em-massa',
        name: 'RETIFICAR_EM_MASSA',
        component: RetificarEmMassa,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'RETIFICAR_EM_MASSA'
        }
      },
      {
        path: '/manutencao/genciamento-de-modulos',
        name: 'GERENCIAMENTO_DE_MODULOS',
        component: GerenciarModulos,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'GERENCIAMENTO_DE_MODULOS'
        }
      },
      {
        path: '/manutencao/verifica-status-processo',
        name: 'VERIFICA_STATUS_FLOWABLE',
        component: VerificaStatusProcesso,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'VERIFICA_STATUS_FLOWABLE'
        }
      },
      {
        path: '/manutencao/encerrar-conversa',
        name: 'ENCERRAR_CONVERSA_MANUTENCAO',
        component: EncerrarConversa,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'ENCERRAR_CONVERSA_MANUTENCAO'
        }
      },
      {
        path: '/manutencao/visualizar-conversa',
        name: 'VISUALIZAR_CONVERSA_MANUTENCAO',
        component: VisualizarConversa,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'ENCERRAR_CONVERSA_MANUTENCAO'
        }
      },
      {
        path: '/wap-client',
        name: 'WAP_CLIENT',
        component: WapClients,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'WAP_CLIENT'
        }
      },
      {
        path: '/chaves',
        name: 'chave-seguranca',
        component: ChaveSeguranca,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'chave-seguranca'
        }
      },
      {
        path: '/manutencao/processos-com-car-gerado',
        name: 'PROCESSOS_CAR_GERADO',
        component: ProcessosComCarGerado,
        props: {
          isManutencao: true
        },
        meta: {
          isPublic: false,
          routeGroup: 'PROCESSOS_CAR_GERADO'
        }
      },
      {
        codigo: 'LISTAGEM_MODELOS_DESPACHO_NOTIFICACAO_MANUTENCAO',
        path: '/listagemModelosManutencao',
        name: 'listagem-modelos-despacho-notificacao-manutencao',
        component: ModelosListagem,
        props: true,
        meta: {
          isPublic: false
        }
      }
    ]
  }
]

export default manutencao



// WEBPACK FOOTER //
// ./src/router/manutencao.js